/**
 * workflow-mapping — frontend lookup workflow.slug → dept_slug.
 *
 * Criado em AUDITORIA-V2-001 (BUG-V2-050) pra resolver fallback do
 * NotificationsBell quando payload da notif não tem `deptSlug` explícito
 * (notifs antigas pré-deploy desta rodada).
 *
 * Trade-off arquitetural: hardcoded acopla frontend ao schema de workflows.
 * Mas é compat retroativa pra payloads stale — não é o caminho canônico.
 * Caminho canônico: backend popula `payload.deptSlug` em todos os types via
 * `enviarNotificacao` (resolvido pelo `resolveCardDeptSlug` server-side).
 *
 * Quando admin criar novo sub-workflow em runtime (raro — Migration 023 só
 * 3 existem: preventiva/corretiva/vistoria), atualizar este mapa via PR
 * pequeno OU migrar pra endpoint `/api/v1/workflows` cacheado.
 */

/**
 * Mapa workflow.slug → dept_slug. Fonte: Migration 023 + seeds canônicos.
 * Atualizar quando novo workflow for adicionado (raríssimo em produção).
 */
export const WORKFLOW_TO_DEPT: Record<string, string> = {
  comercial: 'comercial',
  preventiva: 'manutencao',
  corretiva: 'manutencao',
  vistoria: 'manutencao',
};

/**
 * Resolve workflow.slug pra dept_slug com fallback grace: se workflow não
 * existe no mapa, devolve o próprio slug (assume que é dept canônico — caso
 * de `comercial`, mas também grace pra workflows futuros não-mapeados).
 *
 * Pra resolução autoritativa, prefira `payload.deptSlug` do backend.
 */
export function workflowToDept(workflow: string): string {
  return WORKFLOW_TO_DEPT[workflow] ?? workflow;
}
